import { render, staticRenderFns } from "./_base-rich-text-editor.vue?vue&type=template&id=42401cd8&scoped=true&"
import script from "./_base-rich-text-editor.vue?vue&type=script&lang=js&"
export * from "./_base-rich-text-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42401cd8",
  null
  
)

export default component.exports